import { useRegisterComponent } from '../../../orchestrator';
import { useAppSelector } from '../../../../stores/redux.store';
import { useForceRedirect } from '../../../../utilities/hooks';
import { useOperationalEvent } from '../../../../utilities/analytics/analytics-web-client';
import { pageId } from '../constants';

/**
 * Sets up page-level concerns: the SLI operational event and subscribes to the
 * redirectTo state to trigger a forced redirect.
 */
export const useMfaPromotePageSetup = () => {
  useRegisterComponent(useMfaPromotePageSetup.name);

  const redirectTo = useAppSelector(state => state.mfaPromote.redirectTo);
  useForceRedirect({ redirectTo });

  useOperationalEvent({
    page: pageId,
    action: 'loadMfaPromotePageSuccessful',
    subject: 'sli',
  });
};
